import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsider = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.69058 13.5032C5.51316 13.5032 6.17999 12.83 6.17999 11.9996C6.17999 11.1692 5.51316 10.4961 4.69058 10.4961C3.868 10.4961 3.20117 11.1692 3.20117 11.9996C3.20117 12.83 3.868 13.5032 4.69058 13.5032Z",
		stroke: "#2C2C27",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.2007 9.88235H12.2078C11.3607 7.61647 9.20075 6 6.65251 6C3.37016 6 0.708984 8.68941 0.708984 12C0.708984 15.3106 3.37016 18 6.65251 18C9.19369 18 11.3607 16.3835 12.2078 14.1176H13.4007L14.5231 13.0588L15.5678 14.1176H16.6125L17.6572 13.0588L18.5819 13.9271L19.5066 13.0588L20.5513 14.1176H21.1937C22.3513 14.1176 23.2902 13.1718 23.2902 12C23.2902 10.8282 22.3513 9.88235 21.1937 9.88235H21.2007Z",
		stroke: "#2C2C27",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgInsider;
